import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import { Segmented } from "antd";
import PreparationLandingPage from "../../../components/b2bCandidate/preparation/PreparationLandingPage";
import FreeGuidesMain from "../../../components/b2bCandidate/preparation/freeGuides/FreeGuidesMain";
import { ROLES } from "../../../constants/UserRoles";

function Preparation() {
  const [selectedTab, setSelectedTab] = useState(() => {
    return sessionStorage.getItem("selectedGuideTab") || "Your Guides";
  });

  useEffect(() => {
    sessionStorage.setItem("selectedGuideTab", selectedTab);
  }, [selectedTab]);

  return (
    <>
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="preparation" userRole={ROLES.b2b_candidate} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="preparation"
            userRole={ROLES.b2b_candidate}
            newTitle="Your Guides"
            noNavigate={true}
            // driverFlag="viewAllGuide"
          />
          <div className="py-[1.1rem] px-[0.8rem] lg:px-6">
            {/* <Segmented
              options={[
                { label: "Your Guides", value: "Your Guides" },
                // { label: "Free Guides", value: "Free Guides" },
              ]}
              value={selectedTab}
              onChange={(e) => setSelectedTab(e)}
              block
              className="w-full max-w-[350px]"
              size="large"
            /> */}
            {selectedTab === "Your Guides" && (
              <PreparationLandingPage setSelectedTab={setSelectedTab} />
            )}
            {selectedTab === "Free Guides" && <FreeGuidesMain />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Preparation;
